<template>
    <div>
        <div class="d-flex mt-4">
            <h5 style="font-weight: bold">THÁI ĐỘ HỌC TẬP</h5>
            <span :class="getLearningAttitude(commentDetail.learning_attitude).class"
                  class="text-white rounded ml-4 p-2">
                {{ getLearningAttitude(commentDetail.learning_attitude).label }}
            </span>
        </div>
        <div class="mt-2" v-for="(item, index) in commentDetail.automatic_comments" :key="index">{{ item }}</div>
        <div>
            <p class="mr-4">Lời nhắc nhở của giảng viên:</p>
            <em class="fst-italic text-muted">" {{commentDetail.comment_phase}} "</em>

        </div>
        <div class=" mt-4">
            <h5 style="font-weight: bold">NĂNG LỰC HỌC TẬP</h5>
            <div class="col-12 row">
                <span v-for="(item, index) in commentDetail.learning_ability" :key="index" class="mr-6 mt-2">
                      <div class="d-flex align-items-center">
                            <strong class="mr-4">{{defineLearningAbility(item, index).label }}:</strong>
                            <span class="rounded p-2 text-white" :class="defineLearningAbility(item, index).class">{{defineLearningAbility(item, index).value }}</span>
                      </div>
                </span>
            </div>
            <div class="pl-4 mt-4">
                <div>
                    <p>Điểm mạnh:</p>
                    <em class="fst-italic text-muted">" {{commentDetail.strengths}} "</em>
                </div>
                <div>
                    <p>Điểm cần cải thiện:</p>
                    <em class="fst-italic text-muted">" {{commentDetail.points_for_improvement}} "</em>
                </div>
                <div>
                    <p>Phương án của giảng viên</p>
                    <em class="fst-italic text-muted">" {{commentDetail.student_support_plan}} "</em>
                </div>
            </div>
        </div>
        <div class="mt-4">
            <h5 style="font-weight: bold">Giảng viên dự đoán khả năng đạt đầu ra</h5>
            <span class="text-white" :class="commentDetail.output_achievability == 1 ? `badge bg-success` : (commentDetail.output_achievability == 2 ? `badge bg-warning` : `badge bg-danger`)">
                {{ability_achieve_output[commentDetail.output_achievability - 1]}}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalDetailLessonFirst",
    props: {
        commentDetail: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data()
    {
        return {
            learning_attitude: [
                {
                    id: 1,
                    label: 'Rất tích cực',
                    class: 'bg-success'
                },
                {
                    id: 2,
                    label: 'Chủ động',
                    class: 'bg-primary'

                },
                {
                    id: 3,
                    label: 'Ổn định',
                    class: 'bg-secondary'

                },
                {
                    id: 4,
                    label: 'Thụ động',
                    class: 'bg-warning'

                },
                {
                    id: 5,
                    label: 'Rất tiêu cực',
                    class: 'bg-danger'

                },
            ],
            evaluate_detail: [

                {
                    label: "Tốt",
                    value: 1,
                    class: 'badge bg-success',
                },
                {
                    label: "Khá",
                    value: 2,
                    class: 'badge bg-warning',
                },
                {
                    label: "Trung bình",
                    value: 3,
                    class: 'badge bg-secondary',
                },
                {
                    label: "Yếu",
                    value: 4,
                    class: 'badge bg-danger',
                }
            ],
            learningAbility: [
                {
                    label: "Listening",
                    value: 'listening',
                    class: 'badge bg-success',
                },
                {
                    label: "Speaking",
                    value: 'speaking',
                    class: 'badge bg-warning text-dark',

                },
                {
                    label: "Reading",
                    value: 'reading',
                    class: 'badge bg-secondary',

                },
                {
                    label: "Writing",
                    value: 'writing',
                    class: 'badge bg-warning text-dark',

                },
                {
                    label: "Vocabulary",
                    value: 'vocabulary',
                    class: 'badge bg-warning text-dark',
                },
            ],
            ability_achieve_output: ['Khả năng đạt đầu ra cao', 'Chưa rõ ràng', 'Nguy cơ Fail khóa']
        }
    },
    mounted() {

    },
    methods: {
        getLearningAttitude(id)
        {
            return this.learning_attitude.find(item => item.id === id)
        },
        defineLearningAbility(id, index)
        {
            return {
                'label': this.learningAbility.find(item => item.value === index).label,
                'class': this.evaluate_detail.find(item => item.value === id).class,
                'value': this.evaluate_detail.find(item => item.value === id).label

            }
        }
    }
}
</script>

<style scoped>
    .bg-success {
        background-color: #0C9200 !important;
    }
</style>